import React from "react";
import { Instagram, Facebook, Youtube, Mail, Phone, MapPin } from "lucide-react";
import { SITE } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#1f1d1a] text-[#e8dfc9] pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-[#3a342c]">
          <div className="md:col-span-5">
            <a href="#top" className="font-display text-3xl md:text-4xl text-[#f5efe6] block mb-5">
              Vow <span className="italic text-[#c9a87c]">&amp;</span> Video <span className="font-light">Essex</span>
            </a>
            <p className="font-light leading-relaxed max-w-md text-[#e8dfc9]/80">
              Cinematic wedding films and photography across Essex, London, Kent and the South East. Award winning, two videographers, every booking.
            </p>
            <p className="mt-5 text-xs tracking-[0.25em] uppercase text-[#c9a87c]">
              Part of{" "}
              <a href={SITE.groupUrl} target="_blank" rel="noreferrer" className="underline underline-offset-4 hover:text-[#f5efe6] transition-colors">
                {SITE.groupName}
              </a>
            </p>
            <div className="flex items-center gap-3 mt-7">
              <a href={SITE.social.instagram} target="_blank" rel="noreferrer" className="p-3 border border-[#3a342c] hover:border-[#c9a87c] hover:text-[#c9a87c] transition-colors" aria-label="Instagram">
                <Instagram size={16} />
              </a>
              <a href={SITE.social.facebook} target="_blank" rel="noreferrer" className="p-3 border border-[#3a342c] hover:border-[#c9a87c] hover:text-[#c9a87c] transition-colors" aria-label="Facebook">
                <Facebook size={16} />
              </a>
              <a href={SITE.social.youtube} target="_blank" rel="noreferrer" className="p-3 border border-[#3a342c] hover:border-[#c9a87c] hover:text-[#c9a87c] transition-colors" aria-label="YouTube">
                <Youtube size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="kicker text-[#c9a87c] mb-5">Explore</p>
            <ul className="space-y-3 text-sm font-light">
              <li><a href="#films" className="hover:text-[#c9a87c] transition-colors">Wedding Films</a></li>
              <li><a href="#services" className="hover:text-[#c9a87c] transition-colors">Services</a></li>
              <li><a href="#venues" className="hover:text-[#c9a87c] transition-colors">Venues</a></li>
              <li><a href="#packages" className="hover:text-[#c9a87c] transition-colors">Packages</a></li>
              <li><a href="#reviews" className="hover:text-[#c9a87c] transition-colors">Reviews</a></li>
              <li><a href="#faq" className="hover:text-[#c9a87c] transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="kicker text-[#c9a87c] mb-5">Get In Touch</p>
            <ul className="space-y-4 text-sm font-light">
              <li className="flex items-start gap-3">
                <MapPin size={15} className="mt-1 text-[#c9a87c] flex-shrink-0" />
                <span>
                  {SITE.address.line1}<br/>
                  {SITE.address.line2}<br/>
                  {SITE.address.line3}
                </span>
              </li>
              <li className="flex items-center gap-3"><Phone size={15} className="text-[#c9a87c]" /> <a href={`tel:${SITE.phone}`} className="hover:text-[#c9a87c] transition-colors">{SITE.phone}</a></li>
              <li className="flex items-center gap-3"><Mail size={15} className="text-[#c9a87c]" /> <a href={`mailto:${SITE.email}`} className="hover:text-[#c9a87c] transition-colors">{SITE.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#e8dfc9]/60">
          <p>© {new Date().getFullYear()} Vow &amp; Video Essex. All rights reserved.</p>
          <p className="tracking-[0.2em] uppercase">
            Built by the{" "}
            <a href={SITE.parentUrl} target="_blank" rel="noreferrer" className="text-[#c9a87c] hover:text-[#f5efe6] transition-colors underline underline-offset-4">
              Wedding Video Essex
            </a>{" "}team
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
